import React, { useState, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import ReactGA from 'react-ga'
import { SkeletonTheme } from 'react-loading-skeleton'

import Card from '../../../../components/Card'
import DownloadCards from '../../../../components/DownloadCards'
import { FaChevronLeft } from 'react-icons/fa'
import { useGetNotificationsById } from '../../../../hooks/useGetNotificationById'
import { useUpdateNotification } from '../../../../hooks/useUpdateNotification'
import { notificationTypes } from '../constants'
import { Checkbox } from '../../../../components/Form'

import * as S from './styles'
import moment from 'moment'
import Alert from '../../../../components/Form/Alert'

const NotificationDetail = () => {
  const history = useHistory()
  const { id } = useParams()
  const { professional, partner } = JSON.parse(localStorage.getItem('userData'))
  const { notification, handleGetNotificationById, loading } = useGetNotificationsById()
  const { handleUpdateNotificationToRead, handleUpdateNotificationToAccepted, loadingAcceptTerms } = useUpdateNotification()
  const [wasAccepted, setWasAccepted] = useState(false)

  const typeNotification = notificationTypes[notification?.notificationType]
  const isOfficial = notification?.notificationType === 'OFFICIAL'
  const professionalId = professional.id
  const partnerId = partner
  const notificationId = id
  const partnerData = notification?.partners.find(partner => partner.partner._id === partnerId && partner.professionals)
  const professionalData = partnerData?.professionals.find(prof => prof.professional._id === professionalId)
  const isRead = professionalData?.read

  useEffect(() => {
    handleGetNotificationById(notificationId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (notification && !isRead) handleUpdateNotificationToRead({ partnerId, notificationId, professionalId })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notification])

  const handleAcceptTerms = () => {
    try {
      handleUpdateNotificationToAccepted({ partnerId, notificationId, professionalId }).then(req => req && setWasAccepted(true))
    } catch (error) {
    }
  }

  const handleBackPage = () => {
    history.push('/notifications')
    ReactGA.pageview('/notifications')
  }

  return (
    <SkeletonTheme baseColor="#D9D9D9">
      <S.Container>
        <S.Button onClick={handleBackPage} outline>
          <FaChevronLeft color='#01878E' size='14' />
          Voltar
        </S.Button>
        <S.StyledCard>
          <Card loading={loading} padding='1rem 1rem 24px 1rem' margin='0 0 8px 0' full skeletonHeight={360} >
            <Alert show={isOfficial}>
              Este é um comunicado jurídico, você deve se manifestar com a ação de “aceite” para confirmar que leu e está de acordo com as informações.
            </Alert>
            <S.CategoryRow>
              <S.Category
                backgroundColor={typeNotification?.backgroundColor}
                color={typeNotification?.color} >
                {typeNotification?.type}
              </S.Category>
            </S.CategoryRow>
            <S.TextBlock>
              <S.Subtitle>{notification?.name}</S.Subtitle>
              <S.Text>{notification?.message}</S.Text>
            </S.TextBlock>
            {notification?.files?.length > 0 && <DownloadCards files={notification.files}/>}
            {isOfficial &&
              <Card loading={loadingAcceptTerms} full>
                {wasAccepted || professionalData.accepted
                  ? (<S.Text hasMargin>Você declarou que leu e está de acordo com as informações enviadas neste comunicado no dia <strong>{moment(professionalData.acceptedAt).format('DD/MM/YYYY')}</strong>.</S.Text>)
                  : <S.Label>
                    <Checkbox
                      disable={professionalData.accepted}
                      display='inline'
                      width='fit-content'
                      onChange={handleAcceptTerms} />
                    <S.Text hasMargin>Declaro que li e estou de acordo com as informações enviadas no comunicado acima.</S.Text>
                  </S.Label>
                }
              </Card>
            }
          </Card>
        </S.StyledCard>
      </S.Container>
    </SkeletonTheme>
  )
}

export default NotificationDetail
